class YotpoLoyaltyHeaderPopup extends HHBaseElement {
  constructor() {
    super()
    this.render = this.render.bind(this)
    this.yotpoLoyaltyMixin = document.querySelector('domaine-yotpo-loyalty')
  }

  get isLoggedIn() {
    return this.getAttribute('logged-in') === 'true'
  }

  get message() {
    return decodeURIComponent(this.getAttribute('next-tier-message'))
  }

  set currentPoints(points) {
    this.querySelector('[data-current-points').innerHTML = points
  }

  set tier(tierName) {
    const targetEl = this.querySelector('[data-tier')
    if (!targetEl) return

    if (!tierName) {
      targetEl.style.display = 'none'
    }

    targetEl.dataset.tier = tierName.toLowerCase()
    targetEl.innerHTML = tierName

  }

  set nextTierMessage({ points, nextTierName }) {
    const nextTierMessage = this.message
      .replace('{points}', points)
      .replace('{tier}', nextTierName)
    this.querySelector('[data-next-tier-message').innerHTML = nextTierMessage
  }

  connectedCallback() {
    if (!this.isLoggedIn) return

    if (this.yotpoLoyaltyMixin.pointsBalance) {
      this.render()
    } else {
      this.yotpoLoyaltyMixin.addEventListener('domaine:swell-api-ready', this.render)
    }
  }

  render({ detail }) {
    this.currentPoints = detail.customerDetails.pointsBalance
    this.tier = detail.customerDetails.vipTier
  }
}

window.customElements.define(
  'yotpo-loyalty-header-popup',
  YotpoLoyaltyHeaderPopup
)
